import requests from "@/request/libraryindex";

// 获取图书馆
export const getalllibrary=()=>requests({url: "api/cloud/library/library",method: "GET"})

// 删除图书馆
export const deleteibrary=(data:any)=>requests({url: "api/cloud/library/library",method: "DELETE",data})

// 添加图书馆 name addr
export const addibrary=(data:any)=>requests({url: "api/cloud/library/library",method: "POST",data})